import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Receipt = () => {
    const Ledcode = localStorage.getItem("Ledcode");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const navigate = useNavigate();
    const [amount, setAmount] = useState('');
    const [paymentType, setPaymentType] = useState('Cash In Hand');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [balance, setBalance] = useState('');

    const today = new Date();
    const currentDate = `${String(today.getDate()).padStart(2, '0')}/${String(
        today.getMonth() + 1
    ).padStart(2, '0')}/${today.getFullYear()}`;

    const handleSubmit = async () => {
        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            alert('Please enter a valid positive amount.');
            return;
        }

        setIsSubmitting(true);

        const payload = {
            date: currentDate,
            amount: parseFloat(amount),
            paymentType,
            ledCode: Ledcode,
        };

        try {
            const response = await fetch(
                `${apiBaseUrl}/user/saveReceipt/JAPAN_ACCESORIES`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (response.ok) {
                alert('Receipt submitted successfully.');
                navigate(-1);
            } else {
                alert('Failed to submit receipt.');
            }
        } catch (error) {
            console.error('Submission Error:', error);
            alert('Something went wrong.');
        }

        setIsSubmitting(false);
    };

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}/user/balance/JAPAN_ACCESORIES/${Ledcode}`
                );
                const data = await response.json();
                if (data.success) {
                    setBalance(data.balance);
                }
            } catch (error) {
                console.error('Error fetching balance:', error);
            }
        };

        fetchBalance();
    }, [Ledcode, apiBaseUrl]);

    return (
        <div className="min-h-screen flex flex-col bg-[#F7F7F7]">
            <div className="sticky top-0 z-50 pb-6">
                <Navbar />
            </div>
            <div className='w-full pb-6 flex flex-col justify-center items-center'>
                <div className="bg-white shadow-2xl rounded-2xl p-10 max-w-lg w-full border-t-8 border-red-400">
                    <h1 className="text-3xl font-extrabold text-center text-red-600 mb-8">🧾 Receipt Entry Form</h1>

                    <div className="mb-5">
                        <label className="block text-base font-semibold text-gray-800 mb-2">📅 Date</label>
                        <input
                            type="text"
                            value={currentDate}
                            readOnly
                            className="w-full border-2 border-red-300 rounded-lg p-3 bg-gray-100 focus:outline-none"
                        />
                    </div>

                    <div className="mb-5">
                        <label className="block text-base font-semibold text-gray-800 mb-2">💰 Amount (INR)</label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter amount"
                            className="w-full border-2 border-red-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-red-400"
                        />
                    </div>

                    <div className="mb-5">
                        <label className="block text-base font-semibold text-gray-800 mb-2">💳 Payment Type</label>
                        <select
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            className="w-full border-2 border-red-300 rounded-lg p-3 bg-white focus:outline-none"
                        >
                            <option value="Cash In Hand">Cash In Hand</option>
                            <option value="Bank">Bank</option>
                        </select>
                    </div>

                    <button
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        className="w-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-bold py-3 rounded-lg hover:from-red-600 hover:to-pink-600 transition duration-300 shadow-md"
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>

                    {balance !== '' && (
                        <div className="mt-8 p-6 border-2 border-dashed border-red-300 bg-red-50 rounded-xl text-center">
                            <p className="text-sm font-medium text-gray-600">📌 Current Balance</p>
                            <p className="text-2xl font-bold text-red-600 mt-1">₹ {balance}</p>
                        </div>
                    )}
                </div>
            </div>

            <div className="mt-[1%] bg-[white]">
                <Footer />
            </div>
        </div>
    );
};

export default Receipt;